import { render, staticRenderFns } from "./exhibition-activity-item.vue?vue&type=template&id=69a1556e&"
import script from "./exhibition-activity-item.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-item.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports